export enum eWebhookEvents {
  'Cambio estado orden de trabajo' = 1,
  'Cambio estado orden' = 2,
  'Cambio estado ASN' = 3
}
